export const CaretLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path stroke="currentColor" strokeLinecap="square" d="M10 13 5 8l5-5" />
  </svg>
);
